import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import delegateEvent from '../utilities/delegateEvent.js';

export default function SwiperSlider() {
  const instances = [];
  return {
    instances: () => instances,
    init: () => {
      const elements = document.querySelectorAll('[data-w-swiper-container]');
      elements.forEach((element) => {
        const instance = {};
        instance.container = element;
        instance.element = element.querySelector('[data-w-swiper]');
        const type = instance.element.getAttribute('data-w-swiper');

        const config = {
          modules: [Navigation],
          slidesPerView: 'auto',
          speed: 700,
          // on: {},
          navigation: {
            disabledClass: 'w-is-disabled',
            prevEl: instance.container.querySelector(
              '[data-w-swiper-goto="prev"]'
            ),
            nextEl: instance.container.querySelector(
              '[data-w-swiper-goto="next"]'
            ),
          },
        };

        if (type === 'feature' || type === 'project') {
          config.spaceBetween = 24;
        }

        instance.swiper = new Swiper(instance.element, config);
        instance.config = config;

        instances.push(instance);
      });

      delegateEvent(
        document,
        'click',
        '[data-w-swiper-goto]',
        (event, element) => {
          const container = element.closest('[data-w-swiper-container]');
          const swiper = container.querySelector('[data-w-swiper]').swiper;
          const target = element.getAttribute('data-w-swiper-goto');
          if (target === 'prev') {
            swiper.slideTo(swiper.realIndex, 700);
          } else if (target === 'next') {
            swiper.slideTo(swiper.realIndex + 0.25, 700);
          } else {
            swiper.slideTo(parseInt(target), 700);
          }
        }
      );
    },
  };
}
